import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@artprov/design-system";
import { getRolUsuario } from "../../services/user/user.service";

const ProtectedRoute = ({ rolPermitido }) => {
    const { authenticated } = useAuth();
    const [rol, setRol] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (authenticated) {
            getRolUsuario()
                .then(data => {
                    setRol(data.rol);
                    setLoading(false);
                })
                .catch(() => {
                    setLoading(false);
                });
        }
    }, [authenticated]);

    if (!authenticated || loading) {
        return null;
    }

    // Validar que el usuario tenga el rol requerido
    if (rolPermitido && (!Array.isArray(rol) || !rol.includes(rolPermitido))) {
        return <Navigate to="/" replace />
    }

    return <Outlet />
};

export default ProtectedRoute;
